// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@flip/XDL/Utilities";
import { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

interface CheckoutStyles {
    sectionTitle: TypographyProps;
    addressDisplay: AddressInfoDisplayStyles;
}

const sharedAddressItemTextStyles: TypographyPresentationProps = {
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
    `,
};

export const checkoutStyles: CheckoutStyles = {
    sectionTitle: {
        variant: "h3",
        css: css`
            margin-bottom: 18px;
        `,
    },

    addressDisplay: {
        firstNameText: sharedAddressItemTextStyles,
        lastNameText: sharedAddressItemTextStyles,
        address1Text: sharedAddressItemTextStyles,
        address2Text: sharedAddressItemTextStyles,
        cityStatePostalCodeText: sharedAddressItemTextStyles,
        stateText: sharedAddressItemTextStyles,
        postalCodeText: sharedAddressItemTextStyles,
        companyNameText: mergeWithCss(sharedAddressItemTextStyles, {
            css: css`
                font-weight: 500;
            `,
        }),
        countryText: sharedAddressItemTextStyles,
        phoneText: mergeWithCss(sharedAddressItemTextStyles, {
            css: css`
                margin: 8px 0;
            `,
        }),
        emailText: sharedAddressItemTextStyles,
    },
};
